// ============================================================
// TĀNTI theme — shared interactions
// ============================================================
document.addEventListener('DOMContentLoaded', () => {

  /* ---------- Mobile nav drawer ---------- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const scrim = document.querySelector('[data-scrim]');

  function openNav(){ mobileNav?.classList.add('open'); scrim?.classList.add('open'); }
  function closeNav(){ mobileNav?.classList.remove('open'); scrim?.classList.remove('open'); }
  menuToggle?.addEventListener('click', openNav);
  menuClose?.addEventListener('click', closeNav);
  scrim?.addEventListener('click', closeNav);

  /* ---------- Search panel toggle ---------- */
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-search-panel]');
  searchToggle?.addEventListener('click', () => {
    searchPanel.hidden = false;
    searchPanel.classList.toggle('open');
    if (searchPanel.classList.contains('open')) searchPanel.querySelector('input')?.focus();
  });

  /* ---------- Cart notification helper ---------- */
  function showCartNotification(message){
    const note = document.getElementById('cart-notification');
    if (!note) return;
    note.textContent = message;
    note.classList.add('show');
    setTimeout(() => note.classList.remove('show'), 2500);
  }

  function updateCartCount(count){
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
  }

  /* ---------- AJAX add to cart (product form + quick add buttons) ---------- */
  function addToCart(variantId, quantity){
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(res => res.json())
    .then(() => fetch('/cart.js').then(r => r.json()))
    .then(cart => { updateCartCount(cart.item_count); return cart; });
  }

  document.querySelectorAll('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      const original = btn.textContent;
      btn.textContent = 'Adding…';
      addToCart(variantId, 1)
        .then(() => { btn.textContent = 'Added ✓'; showCartNotification('Added to cart'); setTimeout(() => btn.textContent = original, 1400); })
        .catch(() => { btn.textContent = 'Try again'; setTimeout(() => btn.textContent = original, 1400); });
    });
  });

  const productForm = document.getElementById('product-form');
  productForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    const variantInput = productForm.querySelector('[data-variant-id-input]');
    const qty = productForm.querySelector('input[name="quantity"]')?.value || 1;
    const btn = document.getElementById('add-cart-btn');
    const original = btn.innerHTML;
    btn.textContent = 'Adding…';
    addToCart(variantInput.value, qty)
      .then(() => { btn.innerHTML = 'Added ✓'; showCartNotification('Added to cart'); setTimeout(() => btn.innerHTML = original, 1400); })
      .catch(() => { btn.textContent = 'Try again'; setTimeout(() => btn.innerHTML = original, 1400); });
  });

  /* ---------- Variant picker (syncs price, image, availability) ---------- */
  const productRoot = document.querySelector('[data-product-json]');
  if (productRoot) {
    let productData;
    try { productData = JSON.parse(productRoot.dataset.productJson); } catch (err) { productData = null; }

    const selections = {};
    productRoot.querySelectorAll('[data-option-selector]').forEach(group => {
      const idx = group.closest('.option-block').dataset.optionIndex;
      const activeEl = group.querySelector('.active');
      selections[idx] = activeEl ? activeEl.dataset.value : null;
    });

    function findMatchingVariant(){
      if (!productData) return null;
      return productData.variants.find(v => {
        return Object.keys(selections).every(idx => {
          const optionKey = 'option' + (parseInt(idx, 10) + 1);
          return v[optionKey] === selections[idx];
        });
      });
    }

    function updateUI(){
      const variant = findMatchingVariant();
      if (!variant) return;

      const variantInput = productRoot.querySelector('[data-variant-id-input]');
      if (variantInput) variantInput.value = variant.id;

      const priceEl = document.getElementById('product-price');
      if (priceEl) {
        const priceStr = (variant.price / 100).toLocaleString(undefined, { style: 'currency', currency: productData.price_currency || 'INR' });
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const wasStr = (variant.compare_at_price / 100).toLocaleString(undefined, { style: 'currency', currency: 'INR' });
          priceEl.innerHTML = `<span class="was">${wasStr}</span>${priceStr}`;
        } else {
          priceEl.textContent = priceStr;
        }
      }

      const addBtn = document.getElementById('add-cart-btn');
      const addPrice = document.getElementById('add-cart-price');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addPrice) addPrice.textContent = (variant.price / 100).toLocaleString(undefined, { style: 'currency', currency: 'INR' });
        addBtn.querySelector ? null : null;
        if (!variant.available) addBtn.textContent = 'Sold Out';
      }

      if (variant.featured_image) {
        const mainImg = document.getElementById('main-product-image');
        if (mainImg) mainImg.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_1000x$2');
      }
    }

    productRoot.querySelectorAll('[data-option-selector]').forEach(group => {
      const idx = group.closest('.option-block').dataset.optionIndex;
      group.querySelectorAll('.swatch, .size-btn').forEach(el => {
        el.addEventListener('click', () => {
          group.querySelectorAll('.swatch, .size-btn').forEach(x => x.classList.remove('active'));
          el.classList.add('active');
          selections[idx] = el.dataset.value;
          const label = group.closest('.option-block').querySelector('.current-option-value');
          if (label) label.textContent = el.dataset.value;
          updateUI();
        });
      });
    });
  }

  /* ---------- Gallery thumbnail swap ---------- */
  const mainImg = document.getElementById('main-product-image');
  document.querySelectorAll('.gallery-thumbs img').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.gallery-thumbs img').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg && thumb.dataset.fullSrc) mainImg.src = thumb.dataset.fullSrc;
    });
  });

  /* ---------- Quantity selector ---------- */
  document.querySelectorAll('.qty-selector').forEach(sel => {
    const input = sel.querySelector('input');
    sel.querySelector('.qty-minus')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    sel.querySelector('.qty-plus')?.addEventListener('click', () => {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* ---------- Size guide modal ---------- */
  const sizeModal = document.querySelector('#size-guide-modal');
  document.querySelectorAll('[data-open-size-guide]').forEach(el => {
    el.addEventListener('click', (e) => { e.preventDefault(); sizeModal?.classList.add('open'); });
  });
  sizeModal?.querySelector('[data-modal-close]')?.addEventListener('click', () => sizeModal.classList.remove('open'));
  sizeModal?.addEventListener('click', (e) => { if (e.target === sizeModal) sizeModal.classList.remove('open'); });

  const unitButtons = document.querySelectorAll('.unit-toggle button');
  unitButtons.forEach(b => b.addEventListener('click', () => {
    unitButtons.forEach(x => x.classList.remove('active'));
    b.classList.add('active');
    const unit = b.dataset.unit;
    document.querySelectorAll('[data-cm]').forEach(cell => {
      cell.textContent = unit === 'in' ? cell.dataset.in : cell.dataset.cm;
    });
  }));

  /* ---------- Product info tabs (accordion) ---------- */
  document.querySelectorAll('.tab-head').forEach(head => {
    head.addEventListener('click', () => {
      const item = head.closest('.tab-item');
      const wasOpen = item.classList.contains('open');
      item.parentElement.querySelectorAll('.tab-item').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* ---------- Testimonial scroller arrows ---------- */
  document.querySelectorAll('[data-scroll-target]').forEach(btn => {
    btn.addEventListener('click', () => {
      const track = document.querySelector(btn.dataset.scrollTarget);
      const dir = btn.dataset.dir === 'prev' ? -1 : 1;
      track?.scrollBy({ left: dir * 336, behavior: 'smooth' });
    });
  });

  /* ---------- Custom tailoring stub form (page.custom-tailoring) ---------- */
  document.querySelectorAll('.stub-form').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const note = form.querySelector('.form-note');
      if (note) note.textContent = 'Thank you — our tailoring team will reach out within 1 business day.';
    });
  });

});
